class UGCVideoSlider extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.ugc-slider__container');

    this.slides = [...this.querySelectorAll('.ugc-slide')].map((slide) => ({
      element: slide,
      poster: slide.querySelector('.ugc-slide__poster'),
      video: slide.querySelector('.ugc-slide__video'),
      title: slide.querySelector('.ugc-slide__title'),
      subtitle: slide.querySelector('.ugc-slide__subtitle'),
      play: slide.querySelector('.ugc-slide__play')
    }));

    this.items = [...this.querySelectorAll('.ugc-data')];

    this.prevButton = this.querySelector('.ugc-slider__button--prev');
    this.nextButton = this.querySelector('.ugc-slider__button--next');

    this.activeSlide = null;
    this.isAnimating = false;
    this.isPlaying = false;
this.pointer = {
  active: false,
  startX: 0,
  startY: 0,
  currentX: 0,
  currentY: 0
};

this.onPointerDown = this.onPointerDown.bind(this);
this.onPointerMove = this.onPointerMove.bind(this);
this.onPointerUp = this.onPointerUp.bind(this);
  }

  connectedCallback() {
    if (!this.slides.length || !this.items.length) return;

    this.bindEvents();
    this.render();
  }

  bindEvents() {
    this.nextButton?.addEventListener('click', () => this.next());

    this.prevButton?.addEventListener('click', () => this.prev());

    this.slides.forEach((slide) => {
      slide.play?.addEventListener('click', (event) => {
        event.preventDefault();
        this.togglePlay(slide);
      });

      slide.video?.addEventListener('click', () => {
        this.togglePlay(slide);
      });

      slide.video?.addEventListener('ended', () => {
        if (slide === this.activeSlide) {
          this.stop();
        }
      });
    });
    this.addEventListener(
  "pointerdown",
  this.onPointerDown
);

window.addEventListener(
  "pointermove",
  this.onPointerMove
);

window.addEventListener(
  "pointerup",
  this.onPointerUp
);

window.addEventListener(
  "pointercancel",
  this.onPointerUp
);
  }

  render() {
    this.slides.forEach((slide, index) => {
      const item = this.items[
        Number(slide.element.dataset.index)
      ];

      this.updateSlide(slide, item);

      const active = index === 2;

      slide.element.classList.toggle(
        'is-active',
        active
      );

      slide.element.classList.remove(
        'is-playing'
      );

      if (active) {
        this.activeSlide = slide;
      }
    });
  }
onPointerDown(e) {
  if (this.isAnimating) return;

  if (
    e.target.closest(".ugc-slide__play") ||
    e.target.closest("video")
  ) {
    return;
  }

  this.pointer.active = true;

  this.pointer.startX = e.clientX;
  this.pointer.startY = e.clientY;
  this.pointer.currentX = e.clientX;
  this.pointer.currentY = e.clientY;
  this.pointer.startTime = performance.now();

}
onPointerMove(e) {
  if (!this.pointer.active) return;

  this.pointer.currentX = e.clientX;
  this.pointer.currentY = e.clientY;
}
onPointerUp(event) {
  if (!this.pointer.active) return;

  this.pointer.active = false;

  const dx =
    this.pointer.currentX -
    this.pointer.startX;

  const dy =
    this.pointer.currentY -
    this.pointer.startY;

  if (Math.abs(dx) < Math.abs(dy)) {
    return;
  }

  if (Math.abs(dx) < 70) {
    return;
  }
  if (dx < 0) {
    this.next();
  } else {
    this.prev();
  }
}
  updateSlide(slide, item) {
    if (!item) return;

    if (slide.poster) {
      slide.poster.src = item.dataset.poster;
    }

    if (slide.video) {
      const src = item.dataset.video;

      if (slide.video.dataset.src !== src) {
        slide.video.pause();
        slide.video.currentTime = 0;

        slide.video.dataset.src = src;

        slide.video.removeAttribute('src');
        slide.video.load();
      }
    }

    if (slide.title) {
      slide.title.textContent =
        item.dataset.title;
    }

    if (slide.subtitle) {
      slide.subtitle.textContent =
        item.dataset.subtitle;
    }
  }
  loop(index) {
    return (
      (index + this.items.length) %
      this.items.length
    );
  }
    togglePlay(slide) {
    if (slide !== this.activeSlide) return;

    if (this.isPlaying) {
      this.stop();
    } else {
      this.play();
    }
  }

  play() {
    if (!this.activeSlide) return;

    const { element, video } = this.activeSlide;

    if (!video) return;

    if (video.dataset.src && video.src !== video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }

    this.stop(false);

    element.classList.add("is-playing");

    video.currentTime = 0;

    video.play().catch(() => {});

    this.isPlaying = true;
  }

  stop(resetState = true) {
    this.slides.forEach((slide) => {
      slide.element.classList.remove("is-playing");

      if (!slide.video) return;

      slide.video.pause();
      slide.video.currentTime = 0;
    });

    if (resetState) {
      this.isPlaying = false;
    }
  }

  next() {
    if (this.isAnimating) return;

    const resume = this.isPlaying;

    this.stop(false);

    this.isAnimating = true;

    this.container.classList.add("is-next");

    setTimeout(() => {
      this.shiftSlides(1);

      this.render();

      this.container.classList.remove("is-next");

      this.isAnimating = false;

      if (resume) {
        requestAnimationFrame(() => {
          this.play();
        });
      }
    }, 180);
  }

  prev() {
    if (this.isAnimating) return;

    const resume = this.isPlaying;

    this.stop(false);

    this.isAnimating = true;

    this.container.classList.add("is-prev");

    setTimeout(() => {
      this.shiftSlides(-1);

      this.render();

      this.container.classList.remove("is-prev");

      this.isAnimating = false;

      if (resume) {
        requestAnimationFrame(() => {
          this.play();
        });
      }
    }, 180);
  }

  shiftSlides(direction) {
    this.slides.forEach((slide) => {
      slide.element.dataset.index = this.loop(
        Number(slide.element.dataset.index) + direction
      );
    });
  }
}

customElements.define(
  "ugc-video-slider",
  UGCVideoSlider
);